import { useRouter } from 'vue-router'

import { SignupSimpleRequestBody } from '@/app/types/api/resources/auth'
import { RoutePath } from '@/app/types/app/routes'

import AuthStoreService from '@/store/services/AuthStoreService'

export default function () {
  const router = useRouter()

  function signup(signupData: SignupSimpleRequestBody) {
    const authService = new AuthStoreService()

    return authService
      .signup(signupData)
      .then(() => router.push(RoutePath.EmailVerify))
  }

  return { signup }
}
